var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiagnosis = function SvgDiagnosis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 42 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M32.75 25.25c2.608-2.555 5.25-5.617 5.25-9.625A9.625 9.625 0 0 0 28.375 6c-3.08 0-5.25.875-7.875 3.5C17.875 6.875 15.705 6 12.625 6A9.625 9.625 0 0 0 3 15.625c0 4.025 2.625 7.087 5.25 9.625l8.007 8.007a6 6 0 0 0 8.486 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "m20.497 9.5-5.18 5.18a3.797 3.797 0 0 0 0 5.39c1.435 1.435 3.728 1.488 5.25.122l3.623-3.325a4.935 4.935 0 0 1 6.632 0l5.18 4.656M31 27l-3.5-3.5M25.75 31.25l-3.5-3.5"
  })));
};
export default SvgDiagnosis;